export default {
	title: 'Parties prenantes',
	context_best: 'Favorable',
	context_worse: 'Hostile',
	zones: {
		positive: 'Zone',
		positive_line2: 'Favorable',
		neutral: 'Neutre',
		negative: 'Zone',
		negative_line2: 'Hostile',
		point_of_view_line1: 'Point',
		point_of_view_line2: 'de',
		point_of_view_line3: 'vue'
	},
	tabs: {
		general: {
			title: 'Général'
		},
		links: {
			title: 'Liens'
		},
		comments: {
			title: 'Historique'
		},
		filters: {
			title: 'Filtres'
		},
		export: {
			title: 'Exporter',
			image: 'Exporter le radar en image'
		},
		risks: {
			title: 'Risques'
		},
		bot: {
			title: 'IA'
		},
		tags: {
			title: 'Tags',
			assigned: 'Tags assignés',
			unassigned: 'Tags non assignés'
		},
		disabled: {
			title: 'Désactivés'
		}
	},
	summary: {
		key_drivers: 'Facteurs clés',
		scenario_score: 'Score du scénario',
		max_value: 'max {{value}}',
		legend: {
			current: 'Actuel',
			scenario: 'Scénario'
		}
	},
	all_tags: 'Filtre des tags',
	links: 'Afficher tous les liens',
	no_tag: 'Aucun tag',

	all_icons: 'Filtre des icônes',
	no_icon: 'Aucune icône',

	all_stakes: 'Filtre des enjeux',
	all_constraints: 'Filtre des indicateurs',
	all_risks: 'Filtre des risques',
	all_opportunities: 'Filtre des ouvertures',

	alignment: {
		title_1: 'Alignement',
		title_2: 'parties prenantes'
	},
	onboarding: {
		title: 'Revue des parties prenantes',
		description:
			"Les acteurs qui pèsent sur votre sujet sont positionnés sur le radar selon leur influence et leur posture. Vérifiez l'alignement et ajustez si vous avez une lecture différente."
	}
};
